import React from "react";
import { Grid, Paper, Typography, CardMedia, Divider } from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { checkIsNullUndefined } from "../../commons/Utils";
import { pageImage, pageSubtitles, pageSubtitles2, pageTitles } from "../../commons/EnumsGeneral";
import { EnumPages } from "../../commons/EnumPages";
import { useTranslation } from "react-i18next";

export function MainBackGroundPage(props) {

    const { page, enterpriseList, idEnterprise } = props;
    const commonClasses = CommonStyles();
    const { t, i18n } = useTranslation();

    const handleSubtitle = () => {
        let auxPagesubtitle = t(pageSubtitles[page]);
        if (page == EnumPages.EnterpriseDelete) {
            let auxEnteprise = enterpriseList.find((enterprise) => enterprise.oid == idEnterprise);
            if (auxEnteprise && auxEnteprise.name) {
                auxPagesubtitle = t("enterpriseDeleteEnterpriseTitle").replace('{enterpriseName}', '"' + auxEnteprise.name + '"');
            } else {
                auxPagesubtitle = t("enterpriseDeleteEnterpriseTitleNoName");
            };
        };
        return (
            <Grid container item xs={12} className={commonClasses.pageSubtitleCard} >
                <Grid item xs={12} lg={4} style={{ padding: "0.66em" }} >
                    <CardMedia className={commonClasses.pageSubtitleCardMedia}>
                        <img
                            className={commonClasses.pageSubtitleCardImgMedia}
                            src={pageImage[page]}
                            alt="pass_on"
                        />
                    </CardMedia>
                </Grid>
                <Grid item xs={12} lg={8} className={commonClasses.pageSubtitleCardTextContainer}>
                    <Typography className={commonClasses.pageSubtitleCardText}>
                        {auxPagesubtitle}
                    </Typography>
                    {!checkIsNullUndefined(pageSubtitles2[page]) && (
                        <>
                            <Divider style={{ height: '2px' }} className={commonClasses.pageSubtitleCardDivider}></Divider>
                            <Typography className={commonClasses.pageSubtitleCardText}>
                                {t(pageSubtitles2[page])}
                            </Typography>
                        </>
                    )}
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid container style={{ marginBottom: "1em" }}>
            <Paper className={commonClasses.pagePaper}>
                <Grid item xs={12} className={commonClasses.pageTitle}>
                    <Typography
                        variant="h4"
                        className={commonClasses.title}
                        noWrap
                    >
                        {t(pageTitles[page])}
                    </Typography>
                </Grid>
                {handleSubtitle()}
                {props.children}
            </Paper>
        </Grid>
    );
}